import { ReactComponent as File } from "../assets/feathericons/file-text.svg";
import { ReactComponent as ChevronUp } from "../assets/feathericons/chevron-up.svg";
import { ReactComponent as ChevronDown } from "../assets/feathericons/chevron-down.svg";
import { ReactComponent as Trash } from "../assets/feathericons/trash.svg";
import { ReactComponent as Star } from "../assets/feathericons/star.svg";

const InputQuestion = ({ list, setList, index }) => {
  // fetch value of my input and save in list
  const fetchInput = (e, index) => {
    const newList = [...list];
    newList[index].name = e.target.value;
    setList(newList);
  };

  // delete question
  const handleDeleteQst = (e, index) => {
    const newList = [...list];
    newList.splice(index, 1);
    setList(newList);
  };

  return (
    <>
      {/* button star or file */}
      {list[index].type === "text" ? (
        <div className="index-question">
          <span>{index + 1} - </span>
          <File style={{ height: 20 }} />
        </div>
      ) : (
        <div className="index-question2">
          <span>{index + 1} - </span>
          <Star style={{ height: 18 }} />
        </div>
      )}
      {/* input */}
      <input
        className="inputText"
        type="text"
        value={list[index].name}
        onChange={(e) => fetchInput(e, index)}
      />
      {/* orders : */}
      <div className="rank">
        <ChevronUp />
      </div>
      <div className="rank">
        <ChevronDown />
      </div>
      {/* delete */}
      <div className="trash" onClick={(e) => handleDeleteQst(e, index)}>
        <Trash style={{ height: 20 }} />
      </div>
    </>
  );
};
export default InputQuestion;
